(() => {
  'use strict';
  globalThis.AsteriaNumerologyContent = Object.freeze({
  "profiles": {
    "1": {
      "shortThemeTr": "Başlangıç ve irade",
      "primaryIntentsTr": [
        "Özgüven",
        "Cesaret",
        "Canlılık ve Motivasyon"
      ],
      "supportIntentsTr": [
        "Disiplin ve Sınırlar",
        "Dönüşüm ve Yeni Başlangıç"
      ],
      "summaryTr": "Bağımsız hareket, başlangıç ve kararlılık temalarının öne çıktığı bir çizgi.",
      "summaryEn": "A path where independence, initiative and determination come to the foreground.",
      "primaryIntentsEn": [
        "Confidence",
        "Courage",
        "Vitality"
      ],
      "summaryIt": "Indipendenza, iniziativa e determinazione caratterizzano simbolicamente questo percorso.",
      "primaryIntentsIt": [
        "Fiducia in sé",
        "Coraggio",
        "Vitalità"
      ]
    },
    "2": {
      "shortThemeTr": "Uyum ve bağ",
      "primaryIntentsTr": [
        "Uyum ve İlişki",
        "Sevgi ve Şefkat",
        "Denge"
      ],
      "supportIntentsTr": [
        "Sakinlik",
        "Zarafet ve İçsel Değer"
      ],
      "summaryTr": "İşbirliği, ilişki ve denge kurma temalarının öne çıktığı bir çizgi.",
      "summaryEn": "A path where cooperation, relationships and balance come to the foreground.",
      "primaryIntentsEn": [
        "Harmony",
        "Love",
        "Balance"
      ],
      "summaryIt": "Collaborazione, relazioni e ricerca dell'equilibrio caratterizzano questo percorso.",
      "primaryIntentsIt": [
        "Armonia",
        "Amore",
        "Equilibrio"
      ]
    },
    "3": {
      "shortThemeTr": "İfade ve yaratıcılık",
      "primaryIntentsTr": [
        "İletişim",
        "Canlılık ve Motivasyon",
        "Berraklık"
      ],
      "supportIntentsTr": [
        "Bilgelik ve Öğrenme",
        "Büyüme ve Yenilenme"
      ],
      "summaryTr": "İfade, merak ve yaratıcı canlılık temalarının öne çıktığı bir çizgi.",
      "summaryEn": "A path where expression, curiosity and creative vitality come to the foreground.",
      "primaryIntentsEn": [
        "Communication",
        "Vitality",
        "Clarity"
      ],
      "summaryIt": "Espressione personale, curiosità e creatività emergono in questo percorso.",
      "primaryIntentsIt": [
        "Comunicazione",
        "Vitalità",
        "Chiarezza"
      ]
    },
    "4": {
      "shortThemeTr": "Yapı ve sağlamlık",
      "primaryIntentsTr": [
        "Disiplin ve Sınırlar",
        "Topraklanma",
        "Odak"
      ],
      "supportIntentsTr": [
        "Denge",
        "Kararlılık"
      ],
      "summaryTr": "Düzen, yapı ve istikrarlı ilerleme temalarının öne çıktığı bir çizgi.",
      "summaryEn": "A path where structure, stability and steady progress come to the foreground.",
      "primaryIntentsEn": [
        "Discipline",
        "Grounding",
        "Focus"
      ],
      "summaryIt": "Organizzazione, stabilità e progressi costanti caratterizzano questo percorso.",
      "primaryIntentsIt": [
        "Disciplina",
        "Radicamento",
        "Concentrazione"
      ]
    },
    "5": {
      "shortThemeTr": "Değişim ve hareket",
      "primaryIntentsTr": [
        "Dönüşüm ve Yeni Başlangıç",
        "Büyüme ve Yenilenme",
        "Canlılık ve Motivasyon"
      ],
      "supportIntentsTr": [
        "Bolluk ve Fırsat",
        "İletişim"
      ],
      "summaryTr": "Değişim, hareket ve yeni deneyimlere açıklık temalarının öne çıktığı bir çizgi.",
      "summaryEn": "A path where change, movement and openness to new experiences come to the foreground.",
      "primaryIntentsEn": [
        "Transformation",
        "Growth",
        "Vitality"
      ],
      "summaryIt": "Cambiamento, movimento e apertura a nuove esperienze caratterizzano questo percorso.",
      "primaryIntentsIt": [
        "Trasformazione",
        "Crescita",
        "Vitalità"
      ]
    },
    "6": {
      "shortThemeTr": "Şefkat ve sorumluluk",
      "primaryIntentsTr": [
        "Sevgi ve Şefkat",
        "Uyum ve İlişki",
        "Denge"
      ],
      "supportIntentsTr": [
        "Zarafet ve İçsel Değer",
        "Sakinlik"
      ],
      "summaryTr": "Şefkat, sorumluluk ve uyum kurma temalarının öne çıktığı bir çizgi.",
      "summaryEn": "Life Path 6 highlights care, responsibility, belonging and the creation of harmony in close relationships. Symbolically, it is associated with compassion, balance and a strong sense of beauty and support.",
      "primaryIntentsEn": [
        "Love",
        "Harmony",
        "Balance"
      ],
      "summaryIt": "Il percorso di vita 6 richiama simbolicamente cura, responsabilità, appartenenza e armonia nelle relazioni.",
      "primaryIntentsIt": [
        "Amore",
        "Armonia",
        "Equilibrio"
      ]
    },
    "7": {
      "shortThemeTr": "Derinlik ve içgörü",
      "primaryIntentsTr": [
        "Sezgi ve İçgörü",
        "Berraklık",
        "Bilgelik ve Öğrenme"
      ],
      "supportIntentsTr": [
        "Sakinlik",
        "Odak"
      ],
      "summaryTr": "Araştırma, içgörü ve derin düşünme temalarının öne çıktığı bir çizgi.",
      "summaryEn": "Life Path 7 highlights observation, inquiry, meaning and the desire to look beneath the surface. Symbolically, it is associated with reflection, analysis and intuitive awareness.",
      "primaryIntentsEn": [
        "Intuition",
        "Clarity",
        "Wisdom"
      ],
      "summaryIt": "Il percorso di vita 7 richiama ricerca, riflessione, significato e desiderio di andare oltre le apparenze.",
      "primaryIntentsIt": [
        "Intuizione",
        "Chiarezza",
        "Saggezza"
      ]
    },
    "8": {
      "shortThemeTr": "Yönetim ve sonuç",
      "primaryIntentsTr": [
        "Odak",
        "Özgüven",
        "Disiplin ve Sınırlar"
      ],
      "supportIntentsTr": [
        "Bolluk ve Fırsat",
        "Topraklanma"
      ],
      "summaryTr": "Hedef, yapı ve sonuç alma temalarının öne çıktığı bir çizgi.",
      "summaryEn": "Life Path 8 highlights goals, management, responsibility and tangible outcomes. Symbolically, it is associated with determination, strategic thinking and sustained effort.",
      "primaryIntentsEn": [
        "Focus",
        "Confidence",
        "Discipline"
      ],
      "summaryIt": "Il percorso di vita 8 valorizza obiettivi, organizzazione, responsabilità e risultati concreti.",
      "primaryIntentsIt": [
        "Concentrazione",
        "Fiducia in sé",
        "Disciplina"
      ]
    },
    "9": {
      "shortThemeTr": "Geniş bakış ve tamamlanma",
      "primaryIntentsTr": [
        "Sevgi ve Şefkat",
        "Dönüşüm ve Yeni Başlangıç",
        "Sezgi ve İçgörü"
      ],
      "supportIntentsTr": [
        "Büyüme ve Yenilenme",
        "Sakinlik"
      ],
      "summaryTr": "Geniş bakış, şefkat ve dönüşüm temalarının öne çıktığı bir çizgi.",
      "summaryEn": "Life Path 9 highlights meaning, completion, transformation and a broader view of experience. Symbolically, it is associated with compassion, intuition and seeing beyond purely individual concerns.",
      "primaryIntentsEn": [
        "Love",
        "Transformation",
        "Intuition"
      ],
      "summaryIt": "Il percorso di vita 9 evoca sensibilità, completamento, trasformazione e una visione più ampia.",
      "primaryIntentsIt": [
        "Amore",
        "Trasformazione",
        "Intuizione"
      ]
    },
    "11": {
      "shortThemeTr": "Sezgi ve ilham",
      "primaryIntentsTr": [
        "Sezgi ve İçgörü",
        "Berraklık",
        "İletişim"
      ],
      "supportIntentsTr": [
        "Bilgelik ve Öğrenme",
        "Sakinlik"
      ],
      "summaryTr": "Sezgi, ilham ve hassas algı temalarının daha yoğun okunduğu bir Master Number çizgisi.",
      "summaryEn": "Life Path 11 builds on the sensitivity and relational qualities associated with 2, adding a stronger symbolic emphasis on intuition, inspiration and awareness. It does not imply superiority.",
      "primaryIntentsEn": [
        "Intuition",
        "Clarity",
        "Communication"
      ],
      "summaryIt": "Il numero maestro 11 aggiunge al simbolismo del 2 intuizione, ispirazione e consapevolezza, senza indicare una superiorità.",
      "primaryIntentsIt": [
        "Intuizione",
        "Chiarezza",
        "Comunicazione"
      ]
    },
    "22": {
      "shortThemeTr": "Vizyonu yapıya dönüştürme",
      "primaryIntentsTr": [
        "Disiplin ve Sınırlar",
        "Odak",
        "Büyüme ve Yenilenme"
      ],
      "supportIntentsTr": [
        "Topraklanma",
        "Bolluk ve Fırsat"
      ],
      "summaryTr": "Büyük fikri somut yapıya dönüştürme ve istikrarlı ilerleme temalarının öne çıktığı bir Master Number çizgisi.",
      "summaryEn": "Life Path 22 builds on the structure and discipline associated with 4, adding a symbolic emphasis on turning large ideas into practical, sustainable form. It does not imply superiority.",
      "primaryIntentsEn": [
        "Discipline",
        "Focus",
        "Growth"
      ],
      "summaryIt": "Il numero maestro 22 aggiunge al simbolismo del 4 la capacità di trasformare grandi idee in progetti concreti, senza indicare una superiorità.",
      "primaryIntentsIt": [
        "Disciplina",
        "Concentrazione",
        "Crescita"
      ]
    },
    "33": {
      "shortThemeTr": "Şefkat ve öğretme",
      "primaryIntentsTr": [
        "Sevgi ve Şefkat",
        "Bilgelik ve Öğrenme",
        "Uyum ve İlişki"
      ],
      "supportIntentsTr": [
        "Denge",
        "Zarafet ve İçsel Değer"
      ],
      "summaryTr": "Şefkat, sorumluluk ve paylaşarak öğretme temalarının öne çıktığı bir Master Number çizgisi.",
      "summaryEn": "Life Path 33 builds on the care and responsibility associated with 6, adding a symbolic emphasis on sharing knowledge, guidance and constructive support. It does not imply superiority.",
      "primaryIntentsEn": [
        "Compassion",
        "Wisdom",
        "Harmony"
      ],
      "summaryIt": "Il numero maestro 33 aggiunge al simbolismo del 6 condivisione, orientamento e sostegno costruttivo, senza indicare una superiorità.",
      "primaryIntentsIt": [
        "Compassione",
        "Saggezza",
        "Armonia"
      ]
    }
  },
  "birthdays": {
    "1": {
      "undertone": 1,
      "shortThemeTr": "İnisiyatif ve bağımsızlık",
      "summaryTr": "Doğum Günü 1, kendi başına harekete geçme, öncülük etme ve yeni bir yolu ilk açan kişi olma eğilimini vurgular. Bu sayı, Yaşam Yolu temasına irade, cesaret ve kişisel yön duygusu katar.",
      "shortThemeEn": "Initiative and Independence",
      "summaryEn": "Birthday 1 emphasizes self-starting energy, initiative, and the willingness to lead into new territory. It adds willpower, courage, and a strong sense of personal direction to the Life Path.",
      "shortThemeIt": "Iniziativa e indipendenza",
      "summaryIt": "Il giorno 1 richiama simbolicamente iniziativa, coraggio e capacità di intraprendere la propria strada. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "2": {
      "undertone": 2,
      "shortThemeTr": "Uyum ve arabuluculuk",
      "summaryTr": "Doğum Günü 2, farklı bakış açılarını sezme, uzlaştırma ve ilişkilerde denge kurma yeteneğini vurgular. Yaşam Yolu temasına sabır, iş birliği ve hassasiyet katar.",
      "shortThemeEn": "Harmony and Mediation",
      "summaryEn": "Birthday 2 emphasizes sensitivity to different perspectives, cooperation, and the ability to create balance in relationships. It adds patience, diplomacy, and receptivity to the Life Path.",
      "shortThemeIt": "Armonia e mediazione",
      "summaryIt": "Il giorno 2 richiama simbolicamente ascolto, diplomazia e ricerca dell'equilibrio. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "3": {
      "undertone": 3,
      "shortThemeTr": "İfade ve yaratıcılık",
      "summaryTr": "Doğum Günü 3, düşünceleri ve duyguları yaratıcı biçimde ifade etme yeteneğini öne çıkarır. Yaşam Yolu temasına iletişim, hayal gücü ve canlı bir sosyal ifade katar.",
      "shortThemeEn": "Expression and Creativity",
      "summaryEn": "Birthday 3 highlights a natural ability to communicate thoughts and feelings creatively. It adds expression, imagination, and lively social energy to the Life Path.",
      "shortThemeIt": "Espressione e creatività",
      "summaryIt": "Il giorno 3 richiama simbolicamente comunicazione, immaginazione ed espressione creativa. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "4": {
      "undertone": 4,
      "shortThemeTr": "Düzen ve güvenilirlik",
      "summaryTr": "Doğum Günü 4, işleri sağlam bir zemine oturtma, dikkatli çalışma ve sorumluluklarını istikrarlı biçimde yerine getirme eğilimini vurgular. Yaşam Yolu temasına disiplin, pratiklik ve süreklilik katar.",
      "shortThemeEn": "Structure and Reliability",
      "summaryEn": "Birthday 4 emphasizes careful work, stability, and the ability to build on a solid foundation. It adds discipline, practicality, and consistency to the Life Path.",
      "shortThemeIt": "Organizzazione e affidabilità",
      "summaryIt": "Il giorno 4 richiama simbolicamente stabilità, organizzazione e costanza. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "5": {
      "undertone": 5,
      "shortThemeTr": "Özgürlük ve uyum sağlama",
      "summaryTr": "Doğum Günü 5, değişime hızlı uyum sağlama, yeni deneyimlere açık olma ve insanlarla kolay iletişim kurma eğilimini öne çıkarır. Yaşam Yolu temasına esneklik, merak ve hareket katar.",
      "shortThemeEn": "Freedom and Adaptability",
      "summaryEn": "Birthday 5 emphasizes adaptability, curiosity, and openness to new experiences. It adds flexibility, communication, and a need for movement to the Life Path.",
      "shortThemeIt": "Libertà e adattabilità",
      "summaryIt": "Il giorno 5 richiama simbolicamente curiosità, flessibilità e apertura alle novità. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "6": {
      "undertone": 6,
      "shortThemeTr": "Özen ve sorumluluk",
      "summaryTr": "Doğum Günü 6, ilişkilerde destek olma, sorumluluk üstlenme ve çevresinde uyumlu bir alan yaratma eğilimini vurgular. Yaşam Yolu temasına şefkat, aidiyet ve koruyucu bir yaklaşım katar.",
      "shortThemeEn": "Care and Responsibility",
      "summaryEn": "Birthday 6 emphasizes care, responsibility, and the desire to create harmony around others. It adds compassion, belonging, and a supportive quality to the Life Path.",
      "shortThemeIt": "Cura e responsabilità",
      "summaryIt": "Il giorno 6 richiama simbolicamente cura, responsabilità e armonia nelle relazioni. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "7": {
      "undertone": 7,
      "shortThemeTr": "Araştırma ve içgörü",
      "summaryTr": "Doğum Günü 7, görünenin arkasındaki anlamı araştırma, bilgiyi derinlemesine inceleme ve içgörü geliştirme eğilimini öne çıkarır. Yaşam Yolu temasına analiz, sezgi ve düşünsel derinlik katar.",
      "shortThemeEn": "Inquiry and Insight",
      "summaryEn": "Birthday 7 emphasizes investigation, reflection, and the search for deeper meaning. It adds analysis, intuition, and intellectual depth to the Life Path.",
      "shortThemeIt": "Ricerca e intuizione",
      "summaryIt": "Il giorno 7 richiama simbolicamente ricerca interiore, riflessione e comprensione profonda. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "8": {
      "undertone": 8,
      "shortThemeTr": "Hedef ve yönetim",
      "summaryTr": "Doğum Günü 8, hedef koyma, kaynakları yönetme ve somut sonuç üretme yeteneğini vurgular. Yaşam Yolu temasına hırs, organizasyon ve sonuç odaklılık katar.",
      "shortThemeEn": "Achievement and Management",
      "summaryEn": "Birthday 8 emphasizes goal-setting, management, and the ability to produce tangible results. It adds ambition, organization, and a results-oriented quality to the Life Path.",
      "shortThemeIt": "Realizzazione e gestione",
      "summaryIt": "Il giorno 8 richiama simbolicamente ambizione, organizzazione e capacità di realizzare obiettivi. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "9": {
      "undertone": 9,
      "shortThemeTr": "Şefkat ve geniş bakış",
      "summaryTr": "Doğum Günü 9, bireysel sınırların ötesine bakma, başkalarının deneyimlerine duyarlılık gösterme ve daha geniş bir amaç duygusuyla hareket etme eğilimini vurgular. Yaşam Yolu temasına şefkat, hizmet ve kapsayıcı bakış katar.",
      "shortThemeEn": "Compassion and Perspective",
      "summaryEn": "Birthday 9 emphasizes empathy, service, and the ability to see beyond purely personal concerns. It adds compassion, broad perspective, and a sense of contribution to the Life Path.",
      "shortThemeIt": "Compassione e prospettiva",
      "summaryIt": "Il giorno 9 richiama simbolicamente empatia, generosità e visione ampia. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "10": {
      "undertone": 1,
      "shortThemeTr": "Liderlik ve yön verme",
      "summaryTr": "Doğum Günü 10, fikir üretme, ayrıntıları düzenleme ve bir işi yönlendirme yeteneğini öne çıkarır. Yaşam Yolu temasına bağımsızlık, liderlik ve uygulanabilir düşünme katar.",
      "shortThemeEn": "Leadership and Direction",
      "summaryEn": "Birthday 10 highlights the ability to generate ideas, organize details, and direct action. It adds independence, leadership, and practical initiative to the Life Path.",
      "shortThemeIt": "Leadership e direzione",
      "summaryIt": "Il giorno 10 richiama simbolicamente leadership, iniziativa e orientamento personale. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "11": {
      "undertone": 11,
      "shortThemeTr": "Sezgi ve hassas algı",
      "summaryTr": "Doğum Günü 11, söylenmeyeni fark etme, ince duygusal sinyalleri algılama ve güçlü içgörüler geliştirme eğilimini vurgular. Yaşam Yolu temasına sezgi, duyarlılık ve rehberlik niteliği katar.",
      "shortThemeEn": "Intuition and Sensitivity",
      "summaryEn": "Birthday 11 emphasizes sensitivity to subtle cues, strong intuition, and deep awareness of others. It adds insight, receptivity, and a guiding quality to the Life Path.",
      "shortThemeIt": "Intuizione e sensibilità",
      "summaryIt": "Il giorno 11 richiama simbolicamente sensibilità, intuito e attenzione ai dettagli più sottili. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "12": {
      "undertone": 3,
      "shortThemeTr": "Yaratıcı anlatım",
      "summaryTr": "Doğum Günü 12, hayal gücünü söz, görsel ifade veya yaratıcı üretim yoluyla paylaşma eğilimini öne çıkarır. Yaşam Yolu temasına ifade gücü, yaratıcılık ve sosyal canlılık katar.",
      "shortThemeEn": "Creative Expression",
      "summaryEn": "Birthday 12 emphasizes imagination and the ability to share ideas through words, art, or other forms of expression. It adds creativity, communication, and social vitality to the Life Path.",
      "shortThemeIt": "Espressione creativa",
      "summaryIt": "Il giorno 12 richiama simbolicamente creatività, fantasia e comunicazione. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "13": {
      "undertone": 4,
      "shortThemeTr": "Pratik yaratıcılık",
      "summaryTr": "Doğum Günü 13, yaratıcı fikirleri somut ve uygulanabilir bir biçime dönüştürme eğilimini vurgular. Yaşam Yolu temasına çalışkanlık, pratiklik ve üretken bir yapı duygusu katar.",
      "shortThemeEn": "Practical Creativity",
      "summaryEn": "Birthday 13 emphasizes turning creative ideas into tangible, workable form. It adds diligence, practicality, and productive structure to the Life Path.",
      "shortThemeIt": "Creatività pratica",
      "summaryIt": "Il giorno 13 richiama simbolicamente capacità di trasformare idee creative in risultati concreti. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "14": {
      "undertone": 5,
      "shortThemeTr": "Deneyim ve esneklik",
      "summaryTr": "Doğum Günü 14, yeni deneyimlere açık olma ile adım atmadan önce durumu değerlendirme arasında bir denge kurma eğilimini öne çıkarır. Yaşam Yolu temasına merak, uyum ve ölçülü özgürlük katar.",
      "shortThemeEn": "Experience and Flexibility",
      "summaryEn": "Birthday 14 emphasizes openness to new experiences while retaining a practical sense of timing and judgment. It adds curiosity, adaptability, and measured freedom to the Life Path.",
      "shortThemeIt": "Esperienza e flessibilità",
      "summaryIt": "Il giorno 14 richiama simbolicamente sperimentazione, adattabilità e senso della misura. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "15": {
      "undertone": 6,
      "shortThemeTr": "Destek ve sosyal sıcaklık",
      "summaryTr": "Doğum Günü 15, insanlarla bağ kurma, destek sunma ve deneyimlerini paylaşarak fayda sağlama eğilimini vurgular. Yaşam Yolu temasına sevgi, sosyal açıklık ve sorumluluk katar.",
      "shortThemeEn": "Support and Social Warmth",
      "summaryEn": "Birthday 15 emphasizes connection, support, and the ability to help others through warmth and shared experience. It adds affection, sociability, and responsibility to the Life Path.",
      "shortThemeIt": "Sostegno e calore umano",
      "summaryIt": "Il giorno 15 richiama simbolicamente affetto, socievolezza e sostegno reciproco. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "16": {
      "undertone": 7,
      "shortThemeTr": "Derin analiz ve gerçeği arama",
      "summaryTr": "Doğum Günü 16, yüzeyin altındaki nedenleri araştırma ve insanları ya da olayları derinlemesine çözümleme eğilimini öne çıkarır. Yaşam Yolu temasına analitik düşünce, sezgi ve içsel sorgulama katar.",
      "shortThemeEn": "Deep Analysis and Truth-Seeking",
      "summaryEn": "Birthday 16 emphasizes looking beneath the surface and examining motives, patterns, and meaning. It adds analysis, intuition, and inner inquiry to the Life Path.",
      "shortThemeIt": "Analisi profonda e ricerca della verità",
      "summaryIt": "Il giorno 16 richiama simbolicamente analisi, intuizione e ricerca di significati profondi. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "17": {
      "undertone": 8,
      "shortThemeTr": "Bağımsız başarı",
      "summaryTr": "Doğum Günü 17, kendi başına yüksek standartta iş üretme, hedefe odaklanma ve süreci etkin biçimde yönetme yeteneğini vurgular. Yaşam Yolu temasına bağımsızlık, hırs ve uygulama gücü katar.",
      "shortThemeEn": "Independent Achievement",
      "summaryEn": "Birthday 17 emphasizes independent execution, ambition, and the ability to manage work efficiently from start to finish. It adds focus, self-reliance, and achievement drive to the Life Path.",
      "shortThemeIt": "Realizzazione indipendente",
      "summaryIt": "Il giorno 17 richiama simbolicamente indipendenza, concentrazione e determinazione. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "18": {
      "undertone": 9,
      "shortThemeTr": "Geniş ufuk ve katkı",
      "summaryTr": "Doğum Günü 18, farklı bakış açılarına açık olma ve kişisel gücü daha geniş bir faydaya yöneltme eğilimini öne çıkarır. Yaşam Yolu temasına bağımsızlık, şefkat ve toplumsal bakış katar.",
      "shortThemeEn": "Broad Vision and Contribution",
      "summaryEn": "Birthday 18 emphasizes open-mindedness and the desire to direct personal ability toward a wider benefit. It adds independence, compassion, and social perspective to the Life Path.",
      "shortThemeIt": "Visione ampia e contributo",
      "summaryIt": "Il giorno 18 richiama simbolicamente apertura mentale, compassione e contributo collettivo. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "19": {
      "undertone": 1,
      "shortThemeTr": "Öz yeterlilik ve cesaret",
      "summaryTr": "Doğum Günü 19, kendi kararlarını verme, risk alabilme ve bağımsız biçimde ilerleme eğilimini vurgular. Yaşam Yolu temasına öz yeterlilik, cesaret ve kişisel sorumluluk katar.",
      "shortThemeEn": "Self-Reliance and Courage",
      "summaryEn": "Birthday 19 emphasizes independence, risk-taking, and the drive to make one's own decisions. It adds self-reliance, courage, and personal responsibility to the Life Path.",
      "shortThemeIt": "Autonomia e coraggio",
      "summaryIt": "Il giorno 19 richiama simbolicamente autonomia, coraggio e responsabilità personale. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "20": {
      "undertone": 2,
      "shortThemeTr": "Hassasiyet ve iş birliği",
      "summaryTr": "Doğum Günü 20, insanların ihtiyaçlarını sezme, ilişkilerde uyum yaratma ve karşılıklı anlayışı güçlendirme eğilimini öne çıkarır. Yaşam Yolu temasına hassasiyet, diplomasi ve bağ kurma yeteneği katar.",
      "shortThemeEn": "Sensitivity and Cooperation",
      "summaryEn": "Birthday 20 emphasizes awareness of others, harmony, and mutual understanding. It adds sensitivity, diplomacy, and relationship-building to the Life Path.",
      "shortThemeIt": "Sensibilità e cooperazione",
      "summaryIt": "Il giorno 20 richiama simbolicamente comprensione reciproca, sensibilità e collaborazione. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "21": {
      "undertone": 3,
      "shortThemeTr": "Sosyal ifade ve yaratıcılık",
      "summaryTr": "Doğum Günü 21, insanlarla bağlantı kurarken yaratıcılığı ve güçlü iletişimi kullanma eğilimini vurgular. Yaşam Yolu temasına sosyal çekim, ifade gücü ve ilham verici bir hava katar.",
      "shortThemeEn": "Social Expression and Creativity",
      "summaryEn": "Birthday 21 emphasizes creative communication and connection in social settings. It adds charm, expression, and an inspiring social quality to the Life Path.",
      "shortThemeIt": "Espressione sociale e creatività",
      "summaryIt": "Il giorno 21 richiama simbolicamente comunicazione creativa, socievolezza e ispirazione. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "22": {
      "undertone": 22,
      "shortThemeTr": "Vizyonu somutlaştırma",
      "summaryTr": "Doğum Günü 22, büyük fikirleri düzen, emek ve iş birliğiyle somut yapıya dönüştürme potansiyelini vurgular. Yaşam Yolu temasına vizyon, dayanıklılık ve güçlü uygulama becerisi katar.",
      "shortThemeEn": "Turning Vision into Form",
      "summaryEn": "Birthday 22 emphasizes the ability to build substantial results through vision, discipline, and cooperation. It adds endurance, practical power, and large-scale thinking to the Life Path.",
      "shortThemeIt": "Trasformare le idee in realtà",
      "summaryIt": "Il giorno 22 richiama simbolicamente visione, disciplina e realizzazione di progetti duraturi. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "23": {
      "undertone": 5,
      "shortThemeTr": "Çok yönlülük ve canlılık",
      "summaryTr": "Doğum Günü 23, değişen ortamlara kolay uyum sağlama, farklı deneyimlere yönelme ve insanlarla rahat bağ kurma eğilimini öne çıkarır. Yaşam Yolu temasına esneklik, iyimserlik ve hareket katar.",
      "shortThemeEn": "Versatility and Vitality",
      "summaryEn": "Birthday 23 emphasizes adaptability, variety, and an easy way of connecting with people. It adds flexibility, optimism, and movement to the Life Path.",
      "shortThemeIt": "Versatilità e vitalità",
      "summaryIt": "Il giorno 23 richiama simbolicamente ottimismo, adattabilità e connessione con gli altri. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "24": {
      "undertone": 6,
      "shortThemeTr": "Sadakat ve koruyucu denge",
      "summaryTr": "Doğum Günü 24, ilişkilerde istikrar oluşturma, sevdiklerine karşı sorumluluk üstlenme ve güven veren bir bağ kurma eğilimini vurgular. Yaşam Yolu temasına sadakat, özen ve koruyucu denge katar.",
      "shortThemeEn": "Loyalty and Protective Balance",
      "summaryEn": "Birthday 24 emphasizes stable relationships, loyalty, and responsibility toward loved ones. It adds care, dependability, and a protective sense of balance to the Life Path.",
      "shortThemeIt": "Lealtà ed equilibrio protettivo",
      "summaryIt": "Il giorno 24 richiama simbolicamente lealtà, affidabilità e attenzione agli affetti. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "25": {
      "undertone": 7,
      "shortThemeTr": "Araştırma ve zihinsel derinlik",
      "summaryTr": "Doğum Günü 25, bilgiyi derinlemesine işleme, farklı konuları araştırma ve yüzeysel açıklamalarla yetinmeme eğilimini öne çıkarır. Yaşam Yolu temasına merak, analiz ve güçlü farkındalık katar.",
      "shortThemeEn": "Research and Mental Depth",
      "summaryEn": "Birthday 25 emphasizes deep inquiry, information processing, and a refusal to accept things only at face value. It adds curiosity, analysis, and strong awareness to the Life Path.",
      "shortThemeIt": "Ricerca e profondità mentale",
      "summaryIt": "Il giorno 25 richiama simbolicamente curiosità, ricerca e capacità di analisi. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "26": {
      "undertone": 8,
      "shortThemeTr": "Başarı ve fayda üretme",
      "summaryTr": "Doğum Günü 26, başarı hedefini başkalarına somut fayda sağlayan çözümlerle birleştirme eğilimini vurgular. Yaşam Yolu temasına yönetim, sezgisel ihtiyaç okuma ve pratik sonuç üretme becerisi katar.",
      "shortThemeEn": "Achievement and Practical Benefit",
      "summaryEn": "Birthday 26 emphasizes achieving results while recognizing and responding to the needs of others. It adds management, practical intuition, and solution-oriented thinking to the Life Path.",
      "shortThemeIt": "Realizzazione e utilità pratica",
      "summaryIt": "Il giorno 26 richiama simbolicamente organizzazione, praticità e soluzioni per gli altri. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "27": {
      "undertone": 9,
      "shortThemeTr": "Bilgi ve insani bakış",
      "summaryTr": "Doğum Günü 27, farklı yaşam biçimlerine açık olma, çok yönlü bilgi toplama ve bunu daha geniş bir faydaya dönüştürme eğilimini öne çıkarır. Yaşam Yolu temasına hoşgörü, şefkat ve bilgelik katar.",
      "shortThemeEn": "Knowledge and Human Perspective",
      "summaryEn": "Birthday 27 emphasizes openness to different ways of life and the ability to apply broad knowledge toward a wider good. It adds tolerance, compassion, and wisdom to the Life Path.",
      "shortThemeIt": "Conoscenza e prospettiva umana",
      "summaryIt": "Il giorno 27 richiama simbolicamente conoscenza, tolleranza e saggezza. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "28": {
      "undertone": 1,
      "shortThemeTr": "Liderlik ve iş birliği",
      "summaryTr": "Doğum Günü 28, kendi hedeflerini güçlü biçimde takip ederken başkalarıyla birlikte hareket etmenin değerini fark etme eğilimini vurgular. Yaşam Yolu temasına liderlik, özgüven ve ekipleri bir araya getirme becerisi katar.",
      "shortThemeEn": "Leadership and Cooperation",
      "summaryEn": "Birthday 28 emphasizes ambition and leadership while recognizing the value of working with others. It adds confidence, direction, and the ability to bring people together around a goal.",
      "shortThemeIt": "Leadership e cooperazione",
      "summaryIt": "Il giorno 28 richiama simbolicamente leadership, collaborazione e capacità di riunire le persone. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "29": {
      "undertone": 11,
      "shortThemeTr": "Sezgi ve bağlantıları görme",
      "summaryTr": "Doğum Günü 29, insanlar ve olaylar arasındaki görünmeyen bağlantıları sezme ve karmaşık duygusal örüntüleri fark etme eğilimini öne çıkarır. Yaşam Yolu temasına güçlü sezgi, hassasiyet ve bütünsel bakış katar.",
      "shortThemeEn": "Intuition and Connection",
      "summaryEn": "Birthday 29 emphasizes sensitivity to subtle patterns and the ability to see connections between people and events. It adds intuition, emotional awareness, and a holistic perspective to the Life Path.",
      "shortThemeIt": "Intuizione e connessione",
      "summaryIt": "Il giorno 29 richiama simbolicamente intuizione, sensibilità e riconoscimento delle connessioni. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "30": {
      "undertone": 3,
      "shortThemeTr": "Özgün fikir ve iletişim",
      "summaryTr": "Doğum Günü 30, yaratıcı fikirleri etkili ve canlı bir iletişimle paylaşma eğilimini vurgular. Yaşam Yolu temasına özgünlük, ifade gücü ve iyimser bir anlatım katar.",
      "shortThemeEn": "Original Thought and Communication",
      "summaryEn": "Birthday 30 emphasizes original ideas and the ability to communicate them creatively and effectively. It adds expression, optimism, and inventive thinking to the Life Path.",
      "shortThemeIt": "Pensiero originale e comunicazione",
      "summaryIt": "Il giorno 30 richiama simbolicamente originalità, ottimismo e comunicazione. Queste associazioni offrono uno spunto di riflessione personale."
    },
    "31": {
      "undertone": 4,
      "shortThemeTr": "Pratik hayal gücü ve organizasyon",
      "summaryTr": "Doğum Günü 31, yaratıcı fikirleri düzen, planlama ve çalışkanlıkla uygulanabilir hale getirme eğilimini öne çıkarır. Yaşam Yolu temasına organizasyon, güvenilirlik ve pratik yaratıcılık katar.",
      "shortThemeEn": "Practical Imagination and Organization",
      "summaryEn": "Birthday 31 emphasizes combining imagination with organization and disciplined effort. It adds reliability, planning, and practical creativity to the Life Path.",
      "shortThemeIt": "Immaginazione pratica e organizzazione",
      "summaryIt": "Il giorno 31 richiama simbolicamente immaginazione, pianificazione e disciplina. Queste associazioni offrono uno spunto di riflessione personale."
    }
  }
});
})();
